"use strict";

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

module.exports = function (methodName) {
  return function (object) {
    throw new TypeError(object + " does not have a method '" + methodName + "'.");
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/folktale/helpers/unsupported-method.js
// module id = 280
// module chunks = 34471704633725 35783957827783 216468464745311